import type { ExtensionHandlers } from '@atlaskit/editor-common/extensions';
import type { EditorAppearance } from '@atlaskit/editor-common/types';
import type { ExtensionPluginOptions } from '@atlaskit/editor-plugin-extension';

interface Props {
	options: {
		extensionHandlers?: ExtensionHandlers;
		editorAppearance?: EditorAppearance;
		__rendererExtensionOptions?: ExtensionPluginOptions['__rendererExtensionOptions'];
	};
}

export function extensionPluginOptions({ options }: Props): ExtensionPluginOptions {
	return {
		breakoutEnabled: options.editorAppearance === 'full-page',
		extensionHandlers: options.extensionHandlers,
		useLongPressSelection: false,
		appearance: options.editorAppearance,
		__rendererExtensionOptions: options.__rendererExtensionOptions,
	};
}
